import { FETCH_TRAINER } from './types';

export default {
    [FETCH_TRAINER](state, payload) {
        state.trainer = payload;
    },
};



// WEBPACK FOOTER //
// ./src/store/trainer/mutations.js